app.component("calendarSetting", {
	templateUrl: "app/src/views/templates/calendar-setting.tmpl.html",
	controller: "calendarSettingController",
	bindings: { practiceId: "<" },
});



app.controller('calendarSettingController',['$scope', '$mdDialog', 'PracticeService', "Session","$modal","APPOINTMENT_TYPE","DICOM_MODALITIES",
function($scope, $mdDialog, PracticeService,Session,$modal,APPOINTMENT_TYPE,DICOM_MODALITIES){
   $scope.myColor = '#FF0000';
   $scope.APPOINTMENT_TYPE = APPOINTMENT_TYPE;
   $scope.practiceAPI = PracticeService;
   $scope.appointment_categories = [];
   $scope.$mdDialog = $mdDialog;
   $scope.newType = {colour: 'FFFFFF', duration: 10};
   prepareModalityWidget($scope.newType);
   $scope.Session = Session;
   $scope.saveStatus = '';

   // DICOM modalities an appointment type can be scheduled on.
   $scope.modalityOptions = DICOM_MODALITIES.map(function (modality) {
      return { id: modality.value, label: modality.name };
   });

   $scope.modalitySettings = {
      displayProp: 'label',
      buttonClasses: 'btn btn-dropdown-multiselect',
      showCheckAll: false,
      showUncheckAll: false,
      smartButtonMaxItems: 3,
      dynamicTitle: true,
   };

   // The widget needs a model array on every row, but writing `modalities` is what decides whether a type
   // counts as configured - so that only ever happens in the select/deselect handlers below. Untouched
   // rows keep the key absent and their worklists carry on as before; otherwise a practice editing a
   // colour would silently switch every type to "no imaging". The $$ prefix keeps these view-only
   // properties out of the JSON Angular sends.
   function prepareModalityWidget(type) {
      if (!type) return;

      type.$$modalityModel = (type.modalities || []).map(function (code) {
         return { id: code };
      });

      type.$$modalityEvents = {
         onItemSelect: function () { syncModalities(type); },
         onItemDeselect: function () { syncModalities(type); },
      };
   }

   function syncModalities(type) {
      type.modalities = (type.$$modalityModel || []).map(function (selected) {
         return selected.id;
      });
   }

   // options - if a list is given then choose one of the items. The first item in the list will be the default
$scope.options = {
	hue: true,
	saturation: false,
	lightness: false,
	alpha: false,
	inline: true,
	format: "hex",
	round: false,
	inline: false,
	inputClass: "form-control",
	dynamicHue: false,
	dynamicLightness: false,
	dynamicSaturation: false,
	dynamicAlpha: false,
};

// Which practice this screen edits comes from the rail, not the session.
this.$onInit = function () {
    $scope.practiceId = this.practiceId || (Session.practice && Session.practice.id);
    $scope.practiceName = practiceName($scope.practiceId);
    querySetting();
};

function practiceName(id) {
    const match = (Session.practiceOptions || []).find((p) => p.id === id);
    return (match && match.name) || (Session.practice && Session.practice.name) || "";
}

function querySetting() {
    $scope.practiceAPI.queryCalendarSetting($scope.practiceId)
    .then(
        function (resp) {
            $scope.appointment_categories = resp.data.appointment_categories;
            $scope.appointment_categories.forEach(prepareModalityWidget);
        },
        function (error) {
            console.error(error && error.status);
        }
    );
}
$scope.errors = [];

$scope.renderErrorMessage = function (name, category_id) {
    const val = name && $scope.appointment_categories.find(t=>t.name === name && t.category_id !== category_id);
    if(val && !$scope.errors.some(t=> t === category_id)){
        $scope.errors.push(category_id);
    }else if(!val){
        $scope.errors = $scope.errors.filter(t=> t !== category_id);
    }
    return {
        duplicate: val
    };
}

// Saving keeps the settings dialog open so several sections can be edited in one visit.
$scope.updateSetting = function(){
    // One save at a time - the button stays enabled while it is in flight.
    if($scope.saveStatus === 'Saving...'){
        return;
    }
    if($scope.appointment_categories.some(t=>!t.name) || $scope.errors.length > 0){
        $scope.saveStatus = 'Error: fix the highlighted names first';
        return;
    }
    // Lengths are kept to steps of 5 minutes - the field rounds them, this catches one still being typed.
    if($scope.appointment_categories.some(t=>Number(t.duration) % 5 !== 0)){
        $scope.saveStatus = 'Error: lengths must be in steps of 5 minutes';
        return;
    }
    $scope.saveStatus = 'Saving...';
    $scope.practiceAPI.updateCalendarSetting({appointment_categories: $scope.appointment_categories}, $scope.practiceId)
    .then(
        function (resp) {
            $scope.saveStatus = 'Appointment types saved';
        },
        function (error) {
            console.error(error && error.status);
            $scope.saveStatus = 'Error saving appointment types';
            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "CatTrax has encountered an error",
            });
        }
    );
}

$scope.addSetting = function(){
    // A second click while the first add is in flight created the type twice.
    if($scope.saveStatus === 'Saving...'){
        return;
    }
    if(Number($scope.newType.duration) % 5 !== 0){
        $scope.saveStatus = 'Error: lengths must be in steps of 5 minutes';
        return;
    }
    $scope.saveStatus = 'Saving...';
    $scope.practiceAPI.updateCalendarSetting({appointment_categories: [$scope.newType]}, $scope.practiceId)
    .then(
        function (resp) {
            $scope.newType = {colour: 'FFFFFF', duration: 10};
            prepareModalityWidget($scope.newType);
            $scope.saveStatus = 'Appointment type added';
            querySetting();
        },
        function (error) {
            console.error(error && error.status);
            $scope.saveStatus = 'Error adding appointment type';
            $scope.serverErrorModal = $modal({
                scope: $scope,
                templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
                show: true,
                title: "CatTrax has encountered an error",
            });
        }
    );
}


}]);